import { render, staticRenderFns } from "./confirmSingleFlow.vue?vue&type=template&id=2cf4b208&scoped=true&lang=pug&"
import script from "./confirmSingleFlow.vue?vue&type=script&lang=js&"
export * from "./confirmSingleFlow.vue?vue&type=script&lang=js&"
import style0 from "./confirmSingleFlow.vue?vue&type=style&index=0&id=2cf4b208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4b208",
  null
  
)

export default component.exports